<style>
</style>

<template>

  <div class="modal-backdrop">
    <div class="modal dark-panel mt-5">
      <header class="modal-header">
        <slot name="header">
          <h1>{{trans.get('common.export_ppt_action')}}</h1>
        </slot>
        <button type="button" class="btn-close" @click="close"> x </button>
      </header>

      <section class="modal-body">
        <slot name="body">
            <form id="exportsite" method='post' enctype='multipart/form-data' :action="routesubmit">
              
                <div class="row">
                    <div class="col-lg-6 m-auto text-center">
                        <h3>{{trans.get('common.export.ppt.options.text')}}</h3>
                    </div>
                </div>
                <input type="hidden" name="_token" v-bind:value="csrf">
                <input name="imgSite" type="hidden" id="imgSiteReady" style="visibility: hidden" v-bind:value="imgSiteReady" />
                <div class="row">
                    <div class="col-lg-6 text-right">
                        <input type="checkbox" name="export_eco" id="export_eco" checked/>
                    </div>
                    <div class="col-lg-6 text-left">
                        <label class="text-blue_claire" for="export_eco">{{trans.get('common.export.ppt.options.economy')}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 text-right">
                        <input type="checkbox" name="export_env" id="export_env" checked/>
                    </div>
                    <div class="col-lg-6 text-left">
                        <label class="text-blue_claire" for="export_env">{{trans.get('common.export.ppt.options.environment')}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 text-right">
                        <input type="checkbox" name="export_comm" id="export_comm" checked/>
                    </div>
                    <div class="col-lg-6 text-left">
                        <label class="text-blue_claire" for="export_comm">{{trans.get('common.export.ppt.options.commentaires')}}</label>
                    </div>
                </div>

                <div class="row">
                    <div class="m-auto">
                        <button type="button" class="buttonOriginal2 d-inline-block" aria-label="Left Align" @click="close">
                          <span>{{trans.get('common.cancel')}}</span>
                        </button>
                        <button type="button" class="btn btn-primary text-blue_claire" :title="trans.get('common.validate')" @click="validate">
                        {{trans.get('common.validate')}}
                        </button>
                    </div>
                </div>
            </form>
        </slot>
       </section>

      <footer class="modal-footer">
      </footer>
    </div>
  </div>
</template>


<script>
    export default {
        name: "exportModal",
        props : ['show', 'routesubmit'],     
        data : function(){
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                imgSiteReady: ''
            };
        },
        beforeMount: function() {
        },
        mounted: function(){
            this.imgSiteReady = document.getElementById('imgSite').value;
        },
        methods :{
            close() {
                this.$emit('close');
            },
            validate() {
                document.getElementById('exportsite').submit();
                this.$emit('close');

            }
        }
    }
</script>
<style>
.button-control {
    background-color: white;
    margin: 5px;
}

.button-control > button {
    height: 24px;
    background: rgb(255, 255, 255) none repeat scroll 0% 0% padding-box;
    padding: 3px 4px 4px 4px;
}

.control-left {
    font-size: 20px;
}

  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
  }

  .modal {
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 85%;
    margin-left: 7.5%;
    padding: 3rem;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>